<template>
  <div class="must-read-with-refresh__wrapper">
    <must-read
      :key="
        $_lazyHydratedComponentState_getHydratedComponentRefreshKey(
          $options.consts.HYDRATED_SECTION_NAME
        )
      "
      :last-modified="mustReadItemsLastModified"
      :must-read-items="mustReadItems"
      @mounted="onMounted"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import { RERENDER_MUST_READ_COMPONENT_BUS_NAME } from '@/utils/enums/must-read'
import mixins from '@/utils/mixins'

const HYDRATED_SECTION_NAME = 'MUST_READ'

export default {
  name: 'MustReadWithDelayedContentRefresh',
  mixins: [mixins.lazyHydratedComponentState],
  components: {
    MustRead: hydrateWhenVisible(
      () => import('@/components/_layout/ASidebar/MustRead/index.vue'),
      {
        props: ['last-modified', 'must-read-items']
      }
    )
  },
  consts: {
    HYDRATED_SECTION_NAME
  },
  computed: {
    ...mapGetters({
      mustReadItemsLastModified: 'sidebar/mustReadItemsLastModified',
      mustReadItems: 'sidebar/mustReadItems'
    })
  },
  methods: {
    rerenderSectionOnUpdate() {
      this.$_lazyHydratedComponentState_rerenderNonHydratedComponents([
        HYDRATED_SECTION_NAME
      ])
    },
    onMounted() {
      this.$_lazyHydratedComponentState_onHydratedComponentMounted(
        this.$options.consts.HYDRATED_SECTION_NAME
      )
    }
  },
  beforeMount() {
    this.$bus.$on(
      RERENDER_MUST_READ_COMPONENT_BUS_NAME,
      this.rerenderSectionOnUpdate
    )
  },
  beforeDestroy() {
    this.$bus.$off(
      RERENDER_MUST_READ_COMPONENT_BUS_NAME,
      this.rerenderSectionOnUpdate
    )
  }
}
</script>

<style lang="scss" scoped></style>
